import { connect } from 'react-redux';
import { RetroSynthesisRoot } from '@Pages/RetroSynthesis/RetroSynthesisRoot/RetroSynthesisRoot';

function mapStateToProps() {
  return {};
}

const mapActionToProps = {};

export default connect(mapStateToProps, mapActionToProps)(RetroSynthesisRoot);
